export default __webpack_public_path__ + "static/media/1986.0a237189.png";